<script setup lang="ts">
    import { toRefs } from "vue";
    import KCell from "@/components/KTable/KCell.vue";
    import PreliminarbokningIcon from "@/assets/preliminarbokning.svg";
    import IconLabel from "@/components/IconLabel.vue";

    const props = defineProps<{
        data: boolean;
    }>();

    const { data } = toRefs(props);
</script>

<template>
    <KCell class="cell-preliminarbokning">
        <template #content>
            <IconLabel v-if="data" :icon="PreliminarbokningIcon" text="Preliminärbokad" />
        </template>
    </KCell>
</template>

<style lang="scss">
    .cell-preliminarbokning {
        .icon-label {
            display: flex;
            gap: 4px;
            justify-items: center;
        }
    }
</style>
